import React from 'react'

const ChangeLog = ({ changeLog }) => {
  if (changeLog && changeLog.changeDescriptions) {
    let lines = changeLog.changeDescriptions.split(';')
    return (
      <ul>
        {lines.map((line, index) => (
          <li style={{ padding: '5px 5px' }} key={index}>
            {line}
          </li>
        ))}
      </ul>
    )
  } else {
    return null
  }
}

export default ChangeLog
